import { render } from "./ResponsesDash.vue?vue&type=template&id=2545dfb4"
import script from "./ResponsesDash.vue?vue&type=script&lang=js"
export * from "./ResponsesDash.vue?vue&type=script&lang=js"

import "./ResponsesDash.vue?vue&type=style&index=0&id=2545dfb4&lang=scss"
script.render = render

export default script